
import { useState } from 'react';
// @mui
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import {LoadingButton} from "@mui/lab";
import axios from "../../../../utils/axios";
import {useSnackbar} from "../../../../components/snackbar";

import './Contribuicao.css';

// utils

// components

// ----------------------------------------------------------------------



export default function Contribuicao() {

    const { enqueueSnackbar } = useSnackbar();
const [valor, setvalor] = useState<any>('10');
const [isSubmitSuccessful, setisSubmitSuccessful] = useState<any>(false);
const [dadoscodigo, setdadoscodigo] = useState<any>('vazio');
const [dadosqrcode, setdadosqrcode] = useState<any>('');
const [valorPixGerado, setvalorPixGerado] = useState<any>('10');
const [openPixModal, setOpenPixModal] = useState(false);


  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newvalor: string,
  ) => {
    setvalor(newvalor);
  };

  const pixcopiaecola = async () => {
      setisSubmitSuccessful(true);
      try {
          const response = await axios.post('/areadoheroi/pixcopiaecola',{
              Valor:valor
          });

          const {dadosresponse} = response.data;

          setdadoscodigo(dadosresponse.codigo);
          setdadosqrcode(dadosresponse.qrcode);
          setvalorPixGerado(valor);
          setOpenPixModal(true);
          enqueueSnackbar(`Gerado com sucesso!`, {variant: 'success'});
          setisSubmitSuccessful(false);

      } catch (error) {
          setisSubmitSuccessful(false);
          enqueueSnackbar(`${error.message}`, {variant: 'error'});
      }
  }

  const handleClosePixModal = () => {
      setOpenPixModal(false);
  };




    // This is the function we wrote earlier
  const copyTextToClipboard = async () => {
      

      // if ('clipboard' in navigator) {
      //     return navigator.clipboard.writeText(dadoscodigo);
      // }

      enqueueSnackbar(`Copiado com sucesso!`, {variant: 'success'});
          // return document.execCommand('copy', true, dadoscodigo);
      


    }







  return (
    <>
        <div className='CardContribuaDashboard' id="contribuicao-dashboard">


            <Typography className='TituloCardAzulDashInicialContribua'>Sua contribuição salva vidas</Typography>
            <Typography className='SubtituloCardAzulDashInicialContribua'>Contribua para que mais pessoas possam ser
                acolhidas gratuitamente. Quando você contribui, vidas são salvas.</Typography>

            <Typography className='SelecioneoValorContribua'>Selecione o valor:</Typography>


            <ToggleButtonGroup
                color="primary"
                value={valor}
                exclusive
                onChange={handleChange}
                aria-label="Valor"
                className='OpcoesValorContribua'
            >
                <ToggleButton className='OpcaoValorContribua' value="10">R$10</ToggleButton>
                <ToggleButton className='OpcaoValorContribua' value="20">R$20</ToggleButton>
                <ToggleButton className='OpcaoValorContribua' value="30">R$30</ToggleButton>
            </ToggleButtonGroup>


            <FormControl fullWidth sx={{m: 1}}>
                <TextField
                    className='OutroValorInputContribuaTitulo OutroValorInputContribua'
                    id="outlined-uncontrolled"
                    label="Outro valor"
                    // defaultValue={valor}
                    value={valor === null ? ('') : (valor)}
                    onChange={(event) => setvalor(event.target.value)}
                    fullWidth
                />
            </FormControl>




            <LoadingButton
                fullWidth
                variant="contained"
                loading={isSubmitSuccessful}
                onClick={pixcopiaecola}

            >
                Gerar Pix
            </LoadingButton>

            <Dialog open={openPixModal} onClose={handleClosePixModal} fullWidth maxWidth="xs">
                <DialogTitle sx={{ pb: 1 }}>
                    Obrigado pela sua contribuição
                </DialogTitle>

                <DialogContent>
                    <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
                        Sua contribuição de <b>R${valorPixGerado}</b> ajuda mais pessoas a serem acolhidas gratuitamente.
                    </Typography>

                    {dadosqrcode ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                            <Box
                                component="img"
                                src={dadosqrcode}
                                alt="QR Code Pix"
                                sx={{ width: 200, maxWidth: '100%', borderRadius: 1 }}
                            />
                        </Box>
                    ) : ('')}

                    <TextField
                        label="Código copia e cola"
                        value={dadoscodigo === 'vazio' ? '' : dadoscodigo}
                        fullWidth
                        multiline
                        minRows={3}
                        InputProps={{
                            readOnly: true,
                        }}
                    />
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button onClick={handleClosePixModal} color="inherit">
                        Fechar
                    </Button>

                    <CopyToClipboard text={dadoscodigo === 'vazio' ? '' : dadoscodigo} onCopy={copyTextToClipboard}>
                        <Button variant="contained">
                            Copiar código Pix
                        </Button>
                    </CopyToClipboard>
                </DialogActions>
            </Dialog>

        </div>

    </>
  );
}
